import { useParams, Navigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { PageHeader } from '@/components/sections/PageHeader'
import { Section } from '@/components/ui/Section'
import { LocalizedLink } from '@/components/LocalizedLink'
import { getNewsBySlug, getNewsTranslation } from '@/data/news'
import type { SupportedLanguage } from '@/i18n'
import { PageMeta } from '@/components/PageMeta'
import { Newspaper } from 'lucide-react'

export function NewsDetailPage() {
  const { slug } = useParams<{ slug: string }>()
  const { t, i18n } = useTranslation('pages')
  const lang = i18n.language as SupportedLanguage

  const article = slug ? getNewsBySlug(slug) : undefined
  if (!article) {
    return <Navigate to={`/${lang}/news`} replace />
  }

  const data = getNewsTranslation(article, lang)

  return (
    <>
      <PageMeta title={`${data.title} — FG Automazioni`} description={data.excerpt} />
      <PageHeader
        title={data.title}
        subtitle={article.date}
        tag={t('news.tag')}
        icon={Newspaper}
        gradient="amber"
      />
      <Section background="white" container>
        <div className="mx-auto max-w-[768px]">
          <img
            src={article.image}
            alt={data.title}
            className="mb-8 w-full rounded-lg object-cover"
          />
          <div
            className="prose prose-lg text-gray-700"
            dangerouslySetInnerHTML={{ __html: data.content }}
          />
        </div>
        <div className="mx-auto mt-10 max-w-[768px]">
          <LocalizedLink
            to="news"
            className="inline-flex text-sm font-medium text-[#f75e47] hover:underline"
          >
            ← {t('newsDetail.back')}
          </LocalizedLink>
        </div>
      </Section>
    </>
  )
}
